// Global JS

(function nerivioGlobal($, Drupal) {
  Drupal.behaviors.accessibilityChanges = {
    attach(context) {
      /* Add tabindex attribute to H tags if not present. */
      $('h1, h2, h3, h4, h5, h6', context).each(function() {
        if (!$(this).attr('tabindex')) {
          $(this).attr('tabindex', 0);
        }
      });

      // Custom modal - JS
      // Open modal when anchor link is clicked
      $(".country-selector__region").click(function(e) {
        e.preventDefault();
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "block");
      });

      // Close the modal when close button is clicked
      $(".custom-ui-dialog-titlebar-close, .country-selector-card__cta").click(function() {
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
        $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
        $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open").attr('style', '');
      });

      // Close the modal when clicking outside the modal content
      const $menu = $('.custom-modal'); // This is a selector on which click we dont wont to close.
      $(document).mouseup(e => {
        if (!$menu.is(e.target)
        && $menu.has(e.target).length === 0) {
          $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open").attr('style', '');
        }
      });

      if ($(window).width() < 1280) {
        // Open modal when anchor link is clicked
        $("#shortLanguageCode > svg").click(function(e) {
          e.preventDefault();
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "block");
          $(".lang-selector-dropdown-wrap").addClass("lang-selector-dropdown-open");
        });

        // Close the modal when clicking outside the modal content
        $(".lang-selector-dropdown-wrap + .custom-ui-widget-overlay").on('click', function(e) {
          e.stopImmediatePropagation();
          $(".lang-selector-dropdown-wrap, .lang-selector-dropdown-wrap + .custom-ui-widget-overlay").css("display", "none");
          $(".lang-selector-dropdown-wrap").removeClass("lang-selector-dropdown-open");
        });
      }
    },
  };
})(jQuery, Drupal);

let isThrottled = false;
const throttleDelay = 1000;

function handleScroll() {
  if (isThrottled) {
    return;
  }

  isThrottled = true;

  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = (scrollTop / docHeight) * 100;
  const preciseScrollPercent = Math.min(100, scrollPercent).toFixed(2);

  dataLayer.push({
    event: "page_scroll",
    scroll_percentage: `${preciseScrollPercent}%`,
    ...(window.location.pathname === "/" && { page_origin: "homepage" })
  });

  setTimeout(() => {
    isThrottled = false;
  }, throttleDelay);
}

window.addEventListener("scroll", handleScroll);


document.querySelectorAll('.accordion-item .ac-title').forEach(function(item) {
  item.addEventListener('click', function() {
    const questionText = item.textContent.trim().replace('click to open accordion', '').trim();
    if (window.location.pathname === "/more-research") {
      dataLayer.push({
        event: "additional_research_section",
        selected_section: questionText
      });
    }
    else {
      dataLayer.push({
        event: "nerivio_faq_selected",
        selected_question: questionText,
        ...(window.location.pathname === "/" && { page_origin: "homepage" })
      });
    }
  });
});

const accordionLinks = document.querySelectorAll('.accordion-item .ac-content a');
accordionLinks.forEach(accordionLink => {
  accordionLink.addEventListener('click', handleAccordionLink);
});

function handleAccordionLink(event) {
  const accordionLink = event.currentTarget;
  const linkText = accordionLink.textContent.trim();
  const linkHref = accordionLink.getAttribute("href");

  const accordionItem = accordionLink.closest('.accordion-item');
  const titleElement = accordionItem?.querySelector('.ac-title');
  const questionText = titleElement?.textContent
    .replace('click to open accordion', '')
    .trim();

  if (window.location.pathname === "/more-research") {
    dataLayer.push({
      event: "additional_research_links",
      selected_section: questionText,
      selected_link: linkText
    });
  }
}


document.querySelector('.scientific-evidence__link')?.addEventListener('click', function() {
  dataLayer.push({
    event: "clinical_data_explore",
    ...(window.location.pathname === "/" && { page_origin: "homepage" })
  });
});

document.querySelectorAll('article .toggle-btn').forEach(function(button, index) {
  button.addEventListener('click', function() {
    const article = button.closest('article');

    const testimonialText = article.querySelector('.statistics.contents-wrap p')?.textContent.trim() || '';

    dataLayer.push({
      event: "mirgrane_journey_dropdown",
      user_testimonial: testimonialText,
      position: index,
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  });
});

const questionnaire_buttons = document.querySelectorAll('a.buy-now-new');
questionnaire_buttons.forEach(questionnaire_button => {
  questionnaire_button.addEventListener('click', handleQuestionCtaClick);
});

function handleQuestionCtaClick(event) {
  if (window.location.pathname === "/") {
    dataLayer.push({
      event: "buy_nerivio",
      page: 'Homepage',
      button_clicked: "Questionnaire component"
    });
  }
  if(window.location.pathname === "/pages/drug-free-migraine-relief-treatment") {
    dataLayer.push({
      event: "buy_nerivio",
      page: 'Marketing page',
      button_clicked: "Questionnaire component"
    });
  }
}

const textTags = document.querySelectorAll('.nerivio-text-block a');
textTags.forEach(textTag => {
  textTag.addEventListener('click', handleTextCtaClick);
});

function handleTextCtaClick(event) {
  if (event.currentTarget.classList.contains('buy_nerivio')) {
    dataLayer.push({
      event: "buy_nerivio",
      page: "campaign_page",
      button_clicked: "in_page_button",
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  if (event.currentTarget.classList.contains('postpartum_click')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "postpartum_click",
      page: "Women's health page"
    });
  }

  if (event.currentTarget.classList.contains('nerivio_user_manual')) {
    dataLayer.push({
      event: "nerivio_user_manual",
      page: "How it works",
    });
  }

  if (event.currentTarget.classList.contains('read_article')) {
    const parentDiv = event.currentTarget.closest('.text_block');
    const h2Text = parentDiv ? parentDiv.querySelector('h2')?.textContent.trim() : '';
    dataLayer.push({
      event: "read_article",
      article_name: h2Text,
      page: "Clinical trials"
    });
  }

  if (event.currentTarget.classList.contains('article_selected')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "article_selected",
      article_name: linkClicked
    });
  }

  if (window.location.pathname === "/tracking-migraine-phases") {
    if (event.currentTarget.classList.contains('prodrome_click')) {
      dataLayer.push({
        event: "prodrome_click",
        page: "Tracking Migraine Phases page"
      });
    }
    if (event.currentTarget.classList.contains('aura_click')) {
      dataLayer.push({
        event: "aura_click",
        page: "Tracking Migraine Phases page"
      });
    }
    if (event.currentTarget.classList.contains('headache_click')) {
      dataLayer.push({
        event: "headache_click",
        page: "Tracking Migraine Phases page"
      });
    }
    if (event.currentTarget.classList.contains('postdrome_click')) {
      dataLayer.push({
        event: "postdrome_click",
        page: "Tracking Migraine Phases page"
      });
    }
  }

}

const observer = new MutationObserver(() => {
  const sticky_button = document.querySelector('.sticky-nerivio-clone');
  if (sticky_button) {
    sticky_button.addEventListener('click', () => {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "buy_nerivio",
        page: "campaign_page",
        button_clicked: "sticky_button",
        ...(window.location.pathname === "/" && { page_origin: "homepage" })
      });
    });
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('.nerivio-video-icon-card__video-desktop').forEach(function (videoElement) {
  videoElement.addEventListener('click', function () {
    var titleElement = videoElement.closest('.nerivio-video-icon-card__video-desktop')
      .closest('.nerivio-video-icon-card')
      .querySelector('.nerivio-video-icon-card__content-title');

    var videoName = titleElement ? titleElement.textContent.trim() : 'Unknown';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'nerivio_functions_video_play',
      video_name: videoName,
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("popupVideo");

  if (!video || !video.closest("#videoModal")) return;

  const closeModal = document.getElementById("closeModal");

  let eventSent = false;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  const getVideoName = () => {
    const titleElement = video.closest(".nerivio-video-icon-card")?.querySelector(".nerivio-video-icon-card__content-title");
    return titleElement ? titleElement.textContent.trim() : "Unknown Video";
  };

  const pushVideoStopEvent = (timeInSeconds) => {
    if (eventSent) return;
    eventSent = true;

    dataLayer.push({
      event: "nerivio_functions_video_stop",
      watch_time: formatTime(timeInSeconds),
      video_name: getVideoName(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  };

  const pushMuteEvent = (isMuted) => {
    dataLayer.push({
      event: "nerivio_functions_video_sound",
      action: isMuted ? "Mute" : "Unmute",
      video_name: getVideoName(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  };

  video.addEventListener("pause", () => {
    if (!video.ended && !eventSent) {
      pushVideoStopEvent(video.currentTime);
    }
  });

  closeModal?.addEventListener("mousedown", () => {
    if (!eventSent) {
      pushVideoStopEvent(video.currentTime);
    }
  });

  video.addEventListener("play", () => {
    eventSent = false;
  });

  video.addEventListener("volumechange", () => {
    if (video.muted !== undefined) {
      pushMuteEvent(video.muted);
    }
  });

  const articles = document.querySelectorAll('article.simple-avatar-designation.testimonial-card');

  function getReviewInfo(article) {
    const nameWrapper = article.querySelector('.name-wrapper');
    if (nameWrapper) {
      const nameEl = nameWrapper.querySelector('.avatar-name h3');
      if (nameEl) {
        return nameEl.textContent.trim();
      }
    }
    return '';
  }

  function pushReviewView(article, index) {
    const reviewInfo = getReviewInfo(article);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "hcp_review_view",
      review_info: reviewInfo,
      position: index.toString(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const article = entry.target;
        const index = Array.from(articles).indexOf(article);
        if (index !== -1) {
          pushReviewView(article, index);
          obs.unobserve(article);
        }
      }
    });
  }, { threshold: 0.5 });

  articles.forEach(article => {
    observer.observe(article);
  });

  const articlesStatistics = document.querySelectorAll('article.simple-avatar-statistics.testimonial-card');

  function getUserTestimonial(article_second) {
    const testimonialElement = article_second.querySelector('.testimonial_title');
    if (testimonialElement) {
      return testimonialElement.textContent.trim();
    }
    return '';
  }

  function pushMigraineJourneyView(article_second, index) {
    const userTestimonial = getUserTestimonial(article_second);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "mirgrane_journey_view",
      user_testimonial: userTestimonial,
      position: index.toString(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  const observerStatistics = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const article_second = entry.target;
        const index = Array.from(articlesStatistics).indexOf(article_second);
        if (index !== -1) {
          pushMigraineJourneyView(article_second, index);
          obs.unobserve(article_second);
        }
      }
    });
  }, { threshold: 0.5 });

  articlesStatistics.forEach(article_second => {
    observerStatistics.observe(article_second);
  });

  const articlesScientific = document.querySelectorAll('.scientific-evidence');

  function pushNerivioBenefitsView(article_scientific, index) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "nerivio_benefits_view",
      position: index.toString(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  const observerScientific = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const article_scientific = entry.target;
        const index = Array.from(articlesScientific).indexOf(article_scientific);
        if (index !== -1) {
          pushNerivioBenefitsView(article_scientific, index);
          obs.unobserve(article_scientific);
        }
      }
    });
  }, { threshold: 0.5 });

  articlesScientific.forEach(article_scientific => {
    observerScientific.observe(article_scientific);
  });

  const contactLinks = document.querySelectorAll('.nerivio-contact-block__links-wrap');

  const pushContactEvent = (optionText) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "contact_us",
      selected_option: optionText,
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  };

  contactLinks.forEach(linkWrap => {
    linkWrap.addEventListener('click', function () {
      const optionTextEl = linkWrap.querySelector('.nerivio-contact-block__icon-text');
      if (optionTextEl) {
        const optionText = optionTextEl.textContent.trim();
        if (optionText) {
          pushContactEvent(optionText);
        }
      }
    });
  });

});



document.addEventListener('DOMContentLoaded', function () {
  const splideContainer = document.querySelector('#splide.splide-slider.testimonial-carousel-simple-statistics');
  if (!splideContainer) return;

  const slides = splideContainer.querySelectorAll('article.simple-avatar-statistics.testimonial-card');
  const allSlideElements = Array.from(splideContainer.querySelectorAll('li.splide__slide'));

  function getUserTestimonial(article) {
    const testimonialElement = article.querySelector('.testimonial_title');
    return testimonialElement ? testimonialElement.textContent.trim() : '';
  }

  let lastVisibleIndex = -1;

  function checkAndPushVisibleSlide() {
    const activeSlide = splideContainer.querySelector('li.splide__slide.is-active');
    if (!activeSlide) return;

    const index = allSlideElements.indexOf(activeSlide);
    if (index === -1 || index === lastVisibleIndex) return;

    lastVisibleIndex = index;
    const article = slides[index];
    if (!article) return;

    const userTestimonial = getUserTestimonial(article);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "mirgrane_journey_scroll",
      user_testimonial: userTestimonial,
      position: index.toString(),
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  // Hook into Splide UI controls
  const paginationButtons = splideContainer.querySelectorAll('.splide__pagination__page');
  paginationButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(checkAndPushVisibleSlide, 300);
    });
  });

  const prevArrow = splideContainer.querySelector('.splide__arrow--prev');
  const nextArrow = splideContainer.querySelector('.splide__arrow--next');

  [prevArrow, nextArrow].forEach(arrow => {
    if (arrow) {
      arrow.addEventListener('click', () => {
        setTimeout(checkAndPushVisibleSlide, 300);
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const splideContainer = document.querySelector('#splide.splide-slider.testimonial-carousel-simple-designation');
  if (!splideContainer) return;

  const slides = splideContainer.querySelectorAll('article.testimonial-card');
  const allSlideElements = Array.from(splideContainer.querySelectorAll('li.splide__slide'));

  function getReviewInfo(article) {
    const nameEl = article.querySelector('.avatar-name');
    return nameEl ? nameEl.textContent.trim() : '';
  }

  let lastVisibleIndex = -1;

  function checkAndPushVisibleSlide() {
    const activeSlide = splideContainer.querySelector('li.splide__slide.is-active');
    if (!activeSlide) return;

    const index = allSlideElements.indexOf(activeSlide);
    if (index === -1 || index === lastVisibleIndex) return;

    lastVisibleIndex = index;
    const article = slides[index];
    if (!article) return;

    const reviewInfo = getReviewInfo(article);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "hcp_review_scroll",
      position: index.toString(),
      review_info: reviewInfo,
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }

  // Hook into Splide UI controls
  const paginationButtons = splideContainer.querySelectorAll('.splide__pagination__page');
  paginationButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(checkAndPushVisibleSlide, 300);
    });
  });

  const prevArrow = splideContainer.querySelector('.splide__arrow--prev');
  const nextArrow = splideContainer.querySelector('.splide__arrow--next');

  [prevArrow, nextArrow].forEach(arrow => {
    if (arrow) {
      arrow.addEventListener('click', () => {
        setTimeout(checkAndPushVisibleSlide, 300);
      });
    }
  });
});


document.addEventListener('click', function (event) {
  if (event.target.matches('.check-next')) {
    const wrapper = event.target.closest('.question-wrapper');
    if (!wrapper) return;
    const question = wrapper.querySelector('.form-item__processed_text p')?.innerText || '';
    const selectedOption = wrapper.querySelector('input[type="radio"]:checked');
    const answer = selectedOption ? selectedOption.value : '';
    const allWrappers = Array.from(document.querySelectorAll('.question-wrapper'));
    const position = allWrappers.indexOf(wrapper) + 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "nerivio_questionnaire",
      question: question,
      answer: answer,
      position: position,
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  }
});

// Pass event to datalayer on click of logo.
function handleLogoClick(event) {
  dataLayer.push({
    event: "logo_click",
    ...(window.location.pathname === "/" && { page_origin: "homepage" })
  });
}
const logoLink = document.querySelector('.logo-link');
if (logoLink) {
  logoLink.addEventListener('click', handleLogoClick);
}

// Push events on click of header menu links.
const menuLinks = document.querySelectorAll('.nlevel-menu-default-wrapper a');
function handlemenuClick(event) {
  const button = event.currentTarget.innerText.trim();
  dataLayer.push({
    event: "category_menu",
    button_clicked: button
  });
}
menuLinks.forEach(menuLink => {
  menuLink.addEventListener('click', handlemenuClick);
});

// Push events when user clicks on Buy Nerivio button
const buynowLink = document.querySelectorAll('a[href*="https://neriviodirect.co.uk/"]');
function buyNerivioClick(event) {
  let pageClicked = '';
  const isInHeader = event.currentTarget.closest('.header-nerivio.primary-header') !== null;
  if (isInHeader) {
    pageClicked = "Category Menu"
  }
  else {
    const pathToPageClicked = {
    "/how-it-works": "nerivio_functions_page",
    "/nerivio-teens": "nerivio_teens",
    "/science/clinical-trials": "clinical_trials",
    "/more-research": "additional_research",
    "/migraine-resources": "migraine_resources",
    "/womens-health": "womens_health",
    "/tracking-migraine-phases": "tracking_migraine_phases",
    "/teenagers-parents": "teenagers_and_parents",
    "/faqs": "nerivio_faqs_page",
    "/experts-overview": "experts_overview",
    "/studies": "studies",
    "/contact-us-hcp": "hcp_contact_us_page",
  };

  pageClicked = pathToPageClicked[window.location.pathname] || '';
  }
  if (pageClicked) {
      dataLayer.push({
      event: "buy_nerivio",
      page: pageClicked
    });
  }

}
buynowLink.forEach(link => {
  link.addEventListener("click", buyNerivioClick);
});

// Push events when user clicks on any button in the footer section
function handleFooterClick(event) {
  const buttonClicked = event.currentTarget.textContent.trim();
  dataLayer.push({
    event: "footer_click",
    button_clicked: buttonClicked
  });
}
const footerLinks = document.querySelectorAll('.menu__horizontal--item.menu__item-level-0 a');
footerLinks.forEach(footerLink => {
  footerLink.addEventListener('click', handleFooterClick);
});

// Push events when user changes the country or region
const regionLists = document.querySelectorAll('.country-selector-card__item a');
regionLists.forEach(regionList => {
  regionList.addEventListener('click', handleRegionList);
});

function handleRegionList(event) {
  const region = event.currentTarget.closest('.country-selector-card__item');
  const regionName = region.querySelector('.country-selector-card__name').textContent.trim();
  dataLayer.push({
    event: "change_country",
    country: regionName,
    region: "Europe"
  });
}

// Push events When user views certain pages
document.addEventListener("DOMContentLoaded", function() {
  const pathToPageName = {
  "/how-it-works": "nerivio_functions_page",
  "/nerivio-teens": "nerivio_teens_page",
  "/science/clinical-trials": "clinical_trials_page",
  "/more-research": "more_research_page",
  "/migraine-resources": "migrane_resources_page",
  "/prodrome": "prodrome_page",
  "/aura": "aura_page",
  "/attack": "headache_page",
  "/postdrome": "postdrome_page",
  "/womens-health": "women_health_page",
  "/postpartum": "postpartum_page",
  "/tracking-migraine-phases": "track_migrane_phases_page",
  "/teenagers-parents": "teenagers_and_parents_page",
  "/faqs": "nerivio_faq_page",
  "/experts-overview": "expert_overview_page",
  "/studies": "studies_page",
  "/contact-us-hcp": "hcp_contact_us_page",
};

const pageName = pathToPageName[window.location.pathname];

if (pageName) {
  dataLayer.push({
    event: pageName
  });
}

  const how_it_works_cta = document.querySelector('.how-it-works-cta');

  if (how_it_works_cta) {
    let pageName = '';
    how_it_works_cta.addEventListener('click', function () {
      if (window.location.pathname === "/") {
        pageName = "Homepage";
      }
      if (window.location.pathname === "/pages/drug-free-migraine-relief-treatment") {
        pageName = "Marketing Page";
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'how_it_works',
        page: pageName
      });
    });
  }

  const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.matches && node.matches('.webform-confirmation-modal')) {
          const form_hcp = document.querySelector('.webform-submission-contact-webform-node-441-form');
          if (form_hcp) {
            dataLayer.push({
              event: "hcp_contact_us_submit",
              page: "Contact us HCP",
            });
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const NerivioworksVideo = document.querySelector('.nerivio-video-banner video');
  if (!NerivioworksVideo) return;

  dataLayer.push({
    event: "nerivio_functions_video_play",
    video_name: "Banner video",
    ...(window.location.pathname === "/" && { page_origin: "homepage" })
  });

  // Listen for mute/unmute via volumechange
  NerivioworksVideo.addEventListener('volumechange', function() {
    const isMuted = NerivioworksVideo.muted || NerivioworksVideo.volume === 0;

    dataLayer.push({
      event: "nerivio_functions_video_sound",
      action: isMuted ? "Mute" : "Unmute",
      video_name: "Banner video",
      ...(window.location.pathname === "/" && { page_origin: "homepage" })
    });
  });
});

const textMediaTags = document.querySelectorAll('.text-media a');
textMediaTags.forEach(textTag => {
  textTag.addEventListener('click', handleMediaTextCtaClick);
});

function handleMediaTextCtaClick(event) {
  if (event.currentTarget.classList.contains('migrane_resources_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "migrane_resources_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('women_health_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "women_health_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('track_migrane_phases_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "track_migrane_phases_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('teenagers_and_parents_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "teenagers_and_parents_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('expert_overview_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "expert_overview_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('studies_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "studies_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('print_studies_pdf')) {
    dataLayer.push({
      event: "print_studies_pdf",
    });
  }
  if (event.currentTarget.classList.contains('clinical_trials_pdf')) {
    dataLayer.push({
      event: "clinical_trials_pdf",
    });
  }
  if (event.currentTarget.classList.contains('prodrome_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "prodrome_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('aura_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "aura_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('headache_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "headache_steps",
      selected_step: linkClicked
    });
  }
  if (event.currentTarget.classList.contains('postdrome_steps')) {
    linkClicked = event.currentTarget.textContent.trim();
    dataLayer.push({
      event: "postdrome_steps",
      selected_step: linkClicked
    });
  }

  if (window.location.pathname === "/migraine-resources") {
    if (event.currentTarget.classList.contains('women_health')) {
      dataLayer.push({
        event: "women_health_click",
        page: "Migrane Resources"
      });
    }
    if (event.currentTarget.classList.contains('teenagers_and_parents')) {
      dataLayer.push({
        event: "teenagers_and_parents_click",
        page: "Migrane Resources"
      });
    }
    if (event.currentTarget.classList.contains('track_migrane_phases')) {
      dataLayer.push({
        event: "tracking_migrane_phases_click",
        page: "Migrane Resources"
      });
    }
  }

  if (window.location.pathname === "/womens-health") {
    if (event.currentTarget.classList.contains('postpartum_click')) {
      dataLayer.push({
        event: "postpartum_click",
        page: "Women's health page"
      });
    }
  }

  if (window.location.pathname === "/migraine-resources") {
    if (event.currentTarget.classList.contains('prodrome_click')) {
      dataLayer.push({
        event: "prodrome_click",
        page: "Migrane Resources page"
      });
    }
    if (event.currentTarget.classList.contains('aura_click')) {
      dataLayer.push({
        event: "aura_click",
        page: "Migrane Resources page"
      });
    }
    if (event.currentTarget.classList.contains('headache_click')) {
      dataLayer.push({
        event: "headache_click",
        page: "Migrane Resources page"
      });
    }
    if (event.currentTarget.classList.contains('postdrome_click')) {
      dataLayer.push({
        event: "postdrome_click",
        page: "Migrane Resources page"
      });
    }
  }
}

const fileLinks = document.querySelectorAll('.download-file .file a');
fileLinks.forEach(fileLink => {
  fileLink.addEventListener('click', handleFileLink);
});

function handleFileLink(event) {
  const buttonClicked = event.currentTarget.textContent.trim();
  const buttonUrl = event.currentTarget.getAttribute("href");
  dataLayer.push({
    event: "download_material",
    selected_material: buttonClicked
  });
}

let sourcesClick = document.querySelectorAll('.sources_click');
function NeriviosourcesClick(event) {
  let pageClicked = '';
  linkClicked = event.currentTarget.textContent.trim();
  if (window.location.pathname === "/migraine-resources") {
    pageClicked = "migraine_resources";
  }
  if (window.location.pathname === "/womens-health") {
    pageClicked = "womens_health";
  }
  if (window.location.pathname === "/tracking-migraine-phases") {
    pageClicked = "tracking_migraine_phases";
  }
  if (window.location.pathname === "/teenagers-parents") {
    pageClicked = "teenagers_and_parents";
  }
  dataLayer.push({
    event: "sources_click",
    selected_option: linkClicked,
    page: pageClicked
  });
}

sourcesClick.forEach(link => {
  link.addEventListener("click", NeriviosourcesClick);
});

// Push event on Play/Pause of Video.
const firstVideo = document.querySelector('.nerivio-image video');

function handlevideoPlay(event) {
  dataLayer.push({
    event: "nerivio_treatment_video_play",
    video_name: 'Nerivio treatment video'
  });
}
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}
function handlevideoPause(event) {
  const watchTime = formatTime(event.target.currentTime.toFixed(2));
  dataLayer.push({
    event: "nerivio_treatment_video_stop",
    watch_time: watchTime,
    video_name: 'Nerivio treatment video'
  });
}
if (firstVideo) {
  firstVideo.addEventListener('play', handlevideoPlay);
  firstVideo.addEventListener('pause', handlevideoPause);
}

let nerivio_publishers = document.querySelectorAll('.logos-block .logos-block__url');

function neriviopublishersClick(event) {
  const link = event.currentTarget;
  const selectedText = link.getAttribute('data-link-text');

  dataLayer.push({
    event: "nerivio_publishers",
    selected_option: selectedText,
    ...(window.location.pathname === "/" && { page_origin: "homepage" })
  });
}

nerivio_publishers.forEach(link => {
  link.addEventListener("click", neriviopublishersClick);
});

(function($, Drupal) {
  Drupal.behaviors.showHowItWorksLink = {
    attach: function(context, settings) {
      const $target = $('.nerivio-video-icon-card', context);
      const $desktopLink = $('.menu-how-it-works', context);
      const $mobileLink = $('.menu-how-it-works-mobile', context);

      // Show/hide links based on component presence
      if ($target.length) {
        $desktopLink.removeClass('hidden').show();
        $mobileLink.removeClass('hidden').show();
      } else {
        $desktopLink.hide();
        $mobileLink.hide();
      }

      $mobileLink.off('click').on('click', function(e) {
        e.preventDefault();
        const el = $target.get(0);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }
  };
})(jQuery, Drupal);

(function () {
  const COOKIE_NAME = 'utm_query';
  const COOKIE_EXPIRY_DAYS = 30;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  function shouldCaptureQuery(queryString) {
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_keywords'];
    const params = new URLSearchParams(queryString);
    return utmKeys.some(key => params.has(key));
  }

  function getFullQueryIfUtmExists() {
    const queryString = window.location.search.substring(1);
    return shouldCaptureQuery(queryString) ? queryString : null;
  }

  function appendQueryToLinks(query) {
    const links = document.querySelectorAll('a[href^="https://neriviodirect.co.uk/"]');
    links.forEach(link => {
      const url = new URL(link.href);
      if (!url.searchParams.has('utm_source')) {
        link.href += (url.search ? '&' : '?') + query;
      }
    });
  }

  function handleDynamicLinks(query) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const links = node.querySelectorAll('a[href^="https://neriviodirect.co.uk/"]');
            links.forEach(link => {
              const url = new URL(link.href);
              if (!url.searchParams.has('utm_source')) {
                link.href += (url.search ? '&' : '?') + query;
              }
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const currentQuery = getFullQueryIfUtmExists();
    const savedQuery = getCookie(COOKIE_NAME);
    const queryToUse = currentQuery || savedQuery;

    if (currentQuery) {
      setCookie(COOKIE_NAME, currentQuery, COOKIE_EXPIRY_DAYS);
    }

    if (queryToUse) {
      appendQueryToLinks(queryToUse);
      handleDynamicLinks(queryToUse);
    }
  });
})();